<template>
  <form @submit.prevent="submitParentalLeaveFormForm" novalidate>
    <div class="row me-5 ms-5">
      <div class="col-lg-6 col-lg-6 col-sm-12">
        <Datepicker
            v-model="formParentalLeaveData.startDate"
            :required="true"
            :label="$t('holiday.first_day_of_vacation')"
            position="down"
            :validation="vParentalLeave$.startDate"
            :messages="vParentalLeave$.startDate.required.$message"/>
      </div>
      <div class="col-lg-6 col-lg-6 col-sm-12">
        <Datepicker
            v-model="formParentalLeaveData.endDate"
            :required="true"
            :label="$t('holiday.last_day_of_vacation')"
            position="down"
            :validation="vParentalLeave$.endDate"
            :messages="vParentalLeave$.endDate.required.$message"/>
      </div>
      <div class="d-flex justify-content-center w-100 mt-3">
        <button class="btn btn-primary" type="submit">{{ $t('general.button.save') }}</button>
      </div>
    </div>
  </form>
</template>

<script setup>
import holidayService from '@/api/Holiday';
import Datepicker from '@/components/picker/Datepicker.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { requiredRule } from '@/shared/validators/validationRules';
import Form from '@/views/App/Course/PrivateCoachingModule/Form.vue';
import useVuelidate from '@vuelidate/core';
import { computed, defineEmits, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }        = useI18n();
const isSubmitting = ref(false);
const emit         = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  parentalLeaveId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formParentalLeaveData  = ref({
  startDate: '',
  endDate: '',
});
const formParentalLeaveRules = ref({
  startDate: requiredRule(t),
  endDate: requiredRule(t),
});

const computedRules   = computed(() => formParentalLeaveRules.value);
const vParentalLeave$ = useVuelidate(computedRules, formParentalLeaveData);

async function submitParentalLeaveFormForm() {
  vParentalLeave$.value.$touch();
  if (vParentalLeave$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (props.parentalLeaveId) {
      await holidayService.putParentalLeave(formParentalLeaveData.value, props.parentalLeaveId);
    } else {
      await holidayService.postParentalLeave(formParentalLeaveData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getParentalLeaveData(specialLeaveId) {
  try {
    CloseToast();
    const { data }             = await holidayService.getHolidayDetails(+specialLeaveId);
    formParentalLeaveData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.parentalLeaveId) {
    await getParentalLeaveData(props.parentalLeaveId);
  }
});

</script>
<style scoped>

</style>